import "./styles.css";
export default ({ isXs = false }) => {
  return (
    <div>
      {!isXs && <div></div>}
      {isXs && (
        <div>
          <div className="black-dot-bg-pattern-3-row"></div>
          <div className="black-dot-bg-pattern-3-row"></div>
        </div>
      )}
    </div>
  );
};
